import React, { useCallback, useEffect, useState } from 'react';
import '@ant-design/compatible/assets/index.css';
import _ from 'lodash';
import moment from 'moment';
import {
  Form,
  Tabs,
  Col,
  DatePicker,
  Radio,
  Row,
  Checkbox,
  Typography,
  Collapse,
  Divider,
} from 'antd';
import DF from 'DisplayFramework';
import Text from 'components/Text';
import ParListSelect from 'components/ParListSelect';
import { getProposalById, getProposalUsedAmounts } from 'services/proposal';
import { toCurrency, toRate } from 'utils/utils';

import Value from 'components/Value';
import ElementsFinTable from 'pages/ProposalV3/PropDetail/ElementsFinTable';
import FormInput from 'components/FormInput';
import GetLabel from 'DisplayFramework/components/GetLabel';
import InputCurrency from 'components/InputCurrency/InputCurrency';
import RateFormulaSelect from 'components/RateFormulaSelect';
import InputRate from 'components/InputRate/InputRate';
import Input from 'antd/lib/input/Input';

const { TabPane } = Tabs;
const { Text: AntText } = Typography;
const { Panel } = Collapse;

const TabProposalActivation = (props: any) => {
  const [state, setState] = useState<any>({
    FIN: [],
    ElementFIN: {},
    currcode: '',
    investamount: 0,
    upfrontamount: 0,
    finamount: 0,
    startdate: moment(),
  });

  const initValues = useCallback(() => {
    props.form.setFieldsValue({
      invoiceParticipation: true,
      invoiceUpfront: true,
      invoiceDeferredinterest: true,
      invoiceDeposit: true,
      invoiceFirstrental: true,
      generateDisbursment: false,
      generateCommission: true,
      activationMode: 'PREFIN',
    });
  }, [props.form]);

  const updateState = useCallback(
    (values) => {
      setState((prev: any) => ({ ...prev, ...values }));
    },
    [setState]
  );

  const loadCTDetail = (ctrid: number) => {
    props.setSuccessful(true);

    getProposalById({ ctrid }).then((response) => {
      const proposal = response.data;

      // eslint-disable-next-line no-debugger
      //debugger;

      const ElementsFin = proposal?.conElements.filter(
        (e) => e.ctetype === 'FIN'
      );

      const investAmount = _.sumBy(ElementsFin, 'cteinvestamount');
      const finAmount = _.sumBy(ElementsFin, 'ctefinancedamount');
      const upFrontAmount = _.sumBy(ElementsFin, 'cteupfrontamount');
      const partAmount = _.sumBy(ElementsFin, 'ctepartamount');
      const depositAmount = _.sumBy(ElementsFin, 'ctedepositamount');

      const elemFin = ElementsFin[0];

      getProposalUsedAmounts({ ctrid }).then((response2) => {
        const usedAmounts = response2.data;
        props.form.setFieldsValue({
          investAmountUsed: usedAmounts?.finamountused,
          investAmount: investAmount - usedAmounts?.finamountused,
          finAmount: investAmount - usedAmounts?.finamountused,
        });
      });

      props.form.setFieldsValue({
        event: 'tabProposalActivation',
        partAmount: elemFin!.ctepartamount,
        depositAmount: elemFin!.ctedepositamount,
        upfrontAmount: elemFin!.cteupfrontamount,
        startDate: moment(new Date(), 'YYYY-MM-DD'),
        billingDate: elemFin!.ctebilligdate,
        ctduration: elemFin!.cteduration,
        listAsset: '',
        // activationMode: 'PREFIN',
        prefinmethod: elemFin!.prefinmethod,
        prefinbasis: elemFin!.prefinbasis,
        prefinperiodicity: elemFin!.prefinperiodicity,
        prefinnominalrate: elemFin!.prefinnominalrate,

        prefinratespread: elemFin!.prefinratespread,
        prefinrateref: elemFin!.prefinrateref,

        prefinrateformula: elemFin!.prefinrateformula,
        prefinratetype: elemFin!.prefinratetype,
      });

      updateState({
        currcode: proposal.currcode,
        rentalamount: 0,
        rentalamountinit: elemFin!.cterentalamount,
        investamount: investAmount,
        upfrontAmount: upFrontAmount,
        finamount: finAmount,
        investamountinit: proposal.ctfinancedamount,
      });
      props.setSuccessful(false);
    });
  };

  const toDateString = (momentOrString: any) =>
    momentOrString === undefined
      ? ''
      : typeof momentOrString === 'string'
      ? momentOrString
      : momentOrString.format('YYYY-MM-DD');

  const handleSelectedElement = () => {
    return true;
  };

  const onSaveFinElement = () => {
    return true;
  };

  useEffect(() => {
    props.form.setFieldValue('activationMode', 'PREFIN');
    loadCTDetail(props.objectid);
  }, []);

  return (
    <DF.Provider pagcode="tabcontractactivation">
      <Row>
        <Col span={18}>
          <FormInput
            style={{ margin: 0 }}
            name="activationMode"
            comcode="finactivation"
          >
            <Radio.Group
              defaultValue="PREFIN"
              onChange={() => {
                loadCTDetail(props.objectid);
              }}
              buttonStyle="solid"
            >
              <Radio.Button value="PREFIN">
                <GetLabel label="preFin" />
              </Radio.Button>

              <Radio.Button value="FIN">
                <GetLabel label="finElement" />
              </Radio.Button>
            </Radio.Group>
          </FormInput>
        </Col>
      </Row>
      <Form.Item shouldUpdate noStyle>
        {({ getFieldValue }) => (
          <Tabs animated defaultActiveKey="1">
            {getFieldValue('activationMode') === 'PREFIN' && (
              <TabPane
                tab={<GetLabel label="prefinActivation" />}
                key={1}
                forceRender
              >
                <Row gutter={[8, 8]} style={{ fontWeight: 'bold' }}>
                  <Col span={8}>
                    <Text comcode="finattribute" />
                  </Col>
                  <Col span={4}>
                    <Text comcode="initial" />
                  </Col>
                  <Col span={4}>
                    <Text comcode="alreadyAct" />
                  </Col>
                  <Col span={3}>
                    <Text comcode="toActivate" />
                  </Col>
                  <Col span={5} />
                </Row>

                <Row gutter={[8, 8]}>
                  <Col span={8}>
                    <Text comcode="investamount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="investAmountinit">
                      <AntText>
                        {toCurrency(state.investamountinit, state.currcode)}
                      </AntText>
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="investAmountUsed">
                      <InputCurrency
                        currcode={state.currcode}
                        disabled
                      ></InputCurrency>
                    </Form.Item>
                  </Col>
                  <Col span={3}>
                    <Form.Item style={{ margin: 0 }} name="investAmount">
                      <InputCurrency currcode={state.currcode}></InputCurrency>
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="generateDisbursment"
                      valuePropName="checked"
                    >
                      <Checkbox
                        onChange={(a) => {
                          props?.form.setFieldValue(
                            'generateDisbursment',
                            a.target.checked
                          );
                        }}
                      >
                        <Text comcode="generateDisbursment" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={8}>
                    <Text comcode="elemDescription" />
                  </Col>
                  <Col span={8}>
                    <Form.Item style={{ margin: 0 }} name="elemDescription">
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={3}>
                    <FormInput style={{ margin: 0 }} name="startDate">
                      <DatePicker />
                    </FormInput>
                  </Col>
                  <Col span={5} />
                </Row>

                <Divider></Divider>
                <Row gutter={[8, 8]}>
                  <Col span={8}>
                    <Form.Item
                      name="prefinmethod"
                      shouldUpdate={() => true}
                      noStyle
                    >
                      <FormInput name="prefinmethod">
                        <ParListSelect
                          parcode="PREFINMET"
                          // parvalueparent={getFieldValue('prefinmethod')}
                        />
                      </FormInput>
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <FormInput name="prefinbasis">
                      <ParListSelect parcode="PREFINBAS" />
                    </FormInput>
                  </Col>
                  <Col span={8}>
                    <FormInput name="prefinperiodicity">
                      <ParListSelect
                        parcode="PREFINPER"
                        // parvalueparent={getFieldValue('prefinperiodicity')}
                      />
                    </FormInput>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}>
                  <Col span={8}>
                    <FormInput name="prefinratetype">
                      <ParListSelect parcode="RATETYPE" />
                    </FormInput>
                  </Col>
                  <Col span={8}>
                    <Form.Item shouldUpdate={() => true} noStyle>
                      {({ getFieldValue }) => {
                        return (
                          <FormInput name="prefinrateformula">
                            <RateFormulaSelect
                              params={{
                                formulatype: getFieldValue('prefinratetype'),
                              }}
                            />
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={8}>
                    <FormInput name="prefinrateref">
                      <InputRate disabled />
                    </FormInput>
                  </Col>

                  <Col span={8}>
                    <FormInput name="prefinratespread">
                      <InputRate
                        onChange={(e) => {
                          let prefinrateref =
                            props?.form.getFieldValue('prefinrateref');
                          props?.form.setFieldValue(
                            'prefinnominalrate',
                            Number(e) + prefinrateref
                          );
                        }}
                      />
                    </FormInput>
                  </Col>

                  <Col span={8}>
                    <FormInput name="prefinnominalrate">
                      <Value formatter={toRate} />
                    </FormInput>
                  </Col>
                </Row>
              </TabPane>
            )}
            {getFieldValue('activationMode') === 'FIN' && (
              <TabPane tab="Financial activation" key={2} forceRender>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="investAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="investAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="upfrontAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="upfrontAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceUpfront"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagupfront" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="finAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="finAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="generateDisbursment"
                      valuePropName="checked"
                    >
                      <Checkbox
                        defaultChecked
                        onChange={(a) => {
                          props?.form.setFieldValue(
                            'generateDisbursment',
                            a.target.checked
                          );
                        }}
                      >
                        <Text comcode="generateDisbursment" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="partAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="partAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceParticipation"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagpart" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="depositAmount" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="depositAmount">
                      <Value
                        formatter={(val) => toCurrency(val, state.currcode)}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceDeposit"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagdeposit" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="startDate" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="startDate">
                      <DatePicker />
                    </Form.Item>
                  </Col>
                  <Col span={5} />
                </Row>
                <Row gutter={[8, 8]}>
                  <Col span={6} />
                  <Col span={4}>
                    <Text comcode="billingdate" />
                  </Col>
                  <Col span={4}>
                    <Form.Item style={{ margin: 0 }} name="billingDate">
                      <ParListSelect parcode="BILLDATE" />
                    </Form.Item>
                  </Col>
                  <Col span={5}>
                    <Form.Item
                      style={{ margin: 0 }}
                      name="invoiceDeferredinterest"
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked>
                        <Text comcode="flagdeferredinterest" />
                      </Checkbox>
                    </Form.Item>
                  </Col>
                </Row>

                <Row gutter={[8, 8]}></Row>

                <Form.Item>
                  <ElementsFinTable
                    form={props.form}
                    //elements={[...state?.FIN]}
                    elements={[...(state?.FIN ?? [])]}
                    onDeleteElement={handleSelectedElement}
                    onSelect={handleSelectedElement}
                    onSave={onSaveFinElement}
                    offerid={props.form.getFieldValue('offerid')}
                    prcode={props.form.getFieldValue('prcode')}
                    hideDelete
                  />
                </Form.Item>
              </TabPane>
            )}
          </Tabs>
        )}
      </Form.Item>
    </DF.Provider>
  );
};
export default TabProposalActivation;
